// extracted by mini-css-extract-plugin
export default {"node":"DiagramNode_node__FIaov","node-title":"DiagramNode_node-title__ZtmJ3","dot":"DiagramNode_dot__PBb1v"};